﻿import {
  Clausula,
  ClausulaPesquisa,
  deleteClausula,
  EnviarTodosParaAprovacaoItemClausula,
  getAllClausula,
  getAllClausulaComItemAprovado,
  getAllClausulaComItemPendente,
  getAllClausulaOptions,
  getClausulaComTipo,
  UpdateClausula,
} from '@app/api/minuta/Clausula';
import { getAllTipoClausulaOptions } from '@app/api/minuta/tipoClausula';
import { getAllPerfilOptions } from '@app/api/PerfilAcesso';
import {
  Button,
  CompositeView,
  FormatText,
  FormContext,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormSwitch,
  FormTextArea,
  GridView,
  MasterDetailForm,
  OptionProps,
  SimpleView,
  usePromise,
  Widget,
  useRouter,
  Row,
  Col,
} from '@digital/ui';
import { Modal, Collapse, Icon } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';

import { ModalRichText } from '@app/components';
import { EStatusDoItem } from '@app/enums/EStatusDoItem';

import {
  ClausulaIdPorStatus,
  getAllItemByClausulaIdFilter,
  Item,
  getAllItemByClausulaIdPorStatus,
  UpdateItem,
} from '../../../api/minuta/ItemClausula';
import { newGuid, isValidGuid } from '../../../helpers/geradorGuid';
import ModalSelectResposta from './ModalSelectResposta';
import TabelaItensCadastrados from './TabelaItensCadastrados';
import TabelaOrdenacaoClausulas from './TabelaOrdenacaoClausulas';
import { ModalRichTextModel } from '@app/models/modalRichTextModel';

const { confirm } = Modal;

const Clausula = () => {
  const { formProps } = useContext(FormContext);
  const { Panel } = Collapse;
  const [perfilResponsavelOptions] = usePromise(getAllPerfilOptions, [], [] as OptionProps[]);
  const [tipoClausulaOptions] = usePromise(getAllTipoClausulaOptions, [], [] as OptionProps[]);
  const [clausulaOptions, setClausulaOptions] = useState<OptionProps[]>([]);

  const [clausula, setClausula] = useState<Clausula>();
  const [clausulaResultAprovado, setClausulaResultAprovado] = useState<Clausula[]>([]);
  const [clausulaResultPendente, setClausulaResultPendente] = useState<Clausula[]>([]);
  const [itensRowTable, setItensRowTable] = useState<Item[]>([]);
  const [forceRender, setForceRender] = useState(false);
  const [flag, setFlag] = useState(false);
  const [descricaoDaClausulaCadastroItem, setdescricaoDaClausulaCadastroItem] = useState<string>();
  const [tipoDaClausula, setTipoDaClausula] = useState<string>();
  const [respostasSelecionadas, setRespostasSelecionadas] = useState<string[]>();
  const [initialValue, setInitialValue] = useState<Clausula>();
  const [initialValueFormItensClausula, setInitialValueFormItensClausula] = useState<any>();

  const [itemListComStatusAprovado, setItemListComStatusAprovado] = useState<OptionProps[]>([]);
  const [clausulasComItensAprovados, setClausulasComItensAprovados] = useState<OptionProps[]>([]);
  const [valueSempreVisivel, setValueSempreVisivel] = useState<boolean>(false);

  const [modalVisivel, setModalVisivel] = useState<boolean>(false);
  const [modalRichText, setModalRichText] = useState<ModalRichTextModel>({
    visible: false,
  } as ModalRichTextModel);

  const [clausulaSelect, setClausulaSelect] = useState<Clausula>();

  const { history } = useRouter();
  const params = new URLSearchParams(location.search);

  const clausulaIdParam = isValidGuid(params.get('id') || '') ? params.get('id') : null;

  const definirListadeItens = (event: any) => {
    onUpdateRowTable(event.clausulaId);
  };

  const onUpdateRowTable = (clausulaId: string) => {
    getAllItemByClausulaIdFilter(clausulaId).then(data => {
      if (data) {
        setItensRowTable(data);
      }
    });
  };

  const allItemByClausulaIdPorStatus = (itemId: string) => {
    if (!itemId) {
      return;
    }
    getAllItemByClausulaIdPorStatus({
      clausulaId: itemId,
      stausCodigo: [EStatusDoItem['Aprovado']],
    } as ClausulaIdPorStatus).then(data => {
      if (data) {
        setItemListComStatusAprovado(getAllOptionProps(data));
      } else {
        setItemListComStatusAprovado([]);
      }
    });
  };

  if (clausulaIdParam && flag == false) {
    getAllClausula().then(data => {
      if (data) {
        const result = data.filter(obj => {
          return obj.id === clausulaIdParam;
        });
        if (result && result[0]) {
          setFlag(true);
          const c = {
            id: result[0].id,
            descricao: result[0].descricao,
            tipoClausulaId: result[0].tipoClausulaId,
            itens: result[0].itens,
            mostrarNumero: result[0].mostrarNumero
          } as Clausula;

          setClausula(c);

          if (params.get('editarItem') == 'true') {
            setdescricaoDaClausulaCadastroItem(c.descricao);
            setTipoDaClausula(c.tipoClausulaId);
            definirListadeItens({ clausulaId: c.id });
            allItemByClausulaIdPorStatus(c.id);
          } else {
            setInitialValue(c);
          }
        }
      }
    });
  }

  const onGetAllClausula = () => {
    getAllClausulaOptions().then(respAllClausulas => {
      if (respAllClausulas) {
        setClausulaOptions(respAllClausulas);
      }
    });
  };

  useEffect(() => {
    onGetAllClausula();
  }, [forceRender]);

  useEffect(() => {
    setInitialValueFormItensClausula({
      clausulaId: clausula && clausula.id ? clausula.id : '',
    } as Item);
  }, [clausula]);

  useEffect(() => {
    loadAllClausulasAprovadas();
    loadAllClausulasPendentes({} as ClausulaPesquisa);
  }, []);

  const getAllClausulaOptionProps = (listResult: Clausula[]) => {
    const result: OptionProps[] = [];
    listResult.map(clausula => {
      clausula.itens.map(itemClausula => {
        result.push({
          text: clausula.descricao + ' - ' + itemClausula.descricao,
          value: itemClausula.id.toString(),
        } as OptionProps);
      });
    });

    return result;
  };

  const loadAllClausulasAprovadas = () => {
    getAllClausulaComItemAprovado({} as ClausulaPesquisa).then(data => {
      if (data) {
        setClausulaResultAprovado(data);
        setClausulasComItensAprovados(getAllClausulaOptionProps(data));
      }
    });
  };

  const loadAllClausulasPendentes = (values: ClausulaPesquisa) => {
    getAllClausulaComItemPendente(values).then(data => {
      if (data) {
        setClausulaResultPendente(data);
      }
    });
  };

  const atualizarClausulaPendentes = async () => {
    await loadAllClausulasPendentes({} as ClausulaPesquisa);
  };

  const update = (values: Clausula) => {
    if (values && clausulaIdParam && !values.id) {
      values.id = clausulaIdParam;
    }

    values.mostrarNumero = clausula ? clausula.mostrarNumero : true;

    UpdateClausula(values).then((data: Clausula | any) => {
      if (data && data.id) {
        setClausula({ ...clausula, id: data.id } as Clausula);
        history.push(`./cadastroDeClausula?id=${data.id}`);
        setForceRender(!forceRender);
      }
    });
  };

  const submitFormItemClausulas = async (values: any) => {
    if (respostasSelecionadas) values['respostas'] = respostasSelecionadas;

    if (valueSempreVisivel) values['sempreVisivel'] = valueSempreVisivel;

    const result = await UpdateItem(values);
    if (result) {
      limparFormularioItensClausula();
      onUpdateRowTable(values.clausulaId);
    }

    return result;
  };

  const search = (values: any) => {
    getAllClausulaComItemAprovado(values as ClausulaPesquisa).then(data => {
      if (data) {
        setClausulaResultAprovado(data);
      }
    });
  };

  const limparFormularioItensClausula = () => {
    setInitialValueFormItensClausula({
      ...initialValueFormItensClausula,
      descricaoCompleta: '',
      descricaoHtml: '',
      resposta: '',
      sempreVisivel: false,
    });
    setValueSempreVisivel(false);
  };

  const limparFormularioComValoresIniciais = () => {
    setClausula(undefined);
    setInitialValue(undefined);
    setInitialValue({ ...initialValue, clausula: '', idFace: newGuid() } as Clausula);
  };

  const definirDescricaoDaClausulaCadastroItem = (event: any) => {
    getAllClausula().then(data => {
      if (data) {
        const result = data.filter(obj => {
          return obj.id === event.clausulaId;
        });
        if (result) {
          setdescricaoDaClausulaCadastroItem(result[0].descricao);
        }
      }
    });
  };

  const enviarTodosParaAprovacao = () => {
    const idList = { ids: [] as any };
    itensRowTable.forEach(item => {
      idList['ids'].push(item.id);
    });
    EnviarTodosParaAprovacaoItemClausula(idList).then((data: any) => {
      getAllItemByClausulaIdFilter(itensRowTable[0].clausulaId).then(data => {
        if (data) setItensRowTable(data);
      });

      loadAllClausulasPendentes({} as ClausulaPesquisa);
    });
  };

  const getAllOptionProps = (listResult: Item[]) => {
    return listResult.map(t => ({ text: t.descricao, value: t.id.toString() }));
  };

  const atualizarListClausulasComIntesAprovados = () => {
    setClausulaResultAprovado([]);
    loadAllClausulasAprovadas();
  };

  function mostrarConfirmacaoNovaClausula() {
    confirm({
      title: 'Deseja criar uma nova cláusula?',
      icon: <Icon type="info-circle" />,
      content: 'Ao criar uma nova cláusula você irá descartar todas as alterações que ainda não foram salvas.',
      onOk() {
        window.location.href = `./cadastroDeClausula`;
      },
      onCancel() { },
    });
  }

  function excluirClausula(clausula: Clausula, redirect: string) {
    confirm({
      title: 'Esta ação também excluirá todos os itens(incluindo os itens em aprovação). Continuar?',
      icon: <Icon type="info-circle" />,
      okType: 'danger',
      onOk() {
        if (clausula && clausula.id) {
          deleteClausula(clausula.id)
            .then(() => {
              window.location.href = redirect;
            })
            .catch(() => {
              alert('Erro ao exluir clausula');
            });
        } else {
          alert('Não há clausula para ser excluída');
        }
      },
      onCancel() { },
    });
  }

  const handleModalDescricao = (dadosModal: ModalRichTextModel) => {
    setModalRichText(dadosModal);
    setModalVisivel(dadosModal.visible);
  };

  const handleChangeModalVisible = () => {
    setModalVisivel(!modalVisivel);
    setModalRichText({ visible: !modalVisivel } as ModalRichTextModel);
  };

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-list" noform id="clausulasCadastradasComItensAprovados" title="CLÁUSULAS">
          <Collapse
            key="clausulasCadastradasComItensAprovados"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'clausulasCadastradasComItensAprovados'}>
            <Panel key="clausulasCadastradasComItensAprovados" header="PESQUISAR">
              <MasterDetailForm onSubmit={search}>
                <Widget
                  actions={[
                    true && (
                      <>
                        <Button
                          title="Nova Cláusula"
                          type="primary"
                          style={{ marginLeft: '8px' }}
                          onClick={() => (window.location.href = './cadastroDeClausula')}
                        />
                        <FormSubmitButton noIcon type="primary">
                          <FormatText id="ui.commons.search" uppercase />
                        </FormSubmitButton>
                      </>
                    ),
                  ]}>
                  <FormInput label="Termo de pesquisa" name="termo" span={6} />

                  <FormSelect
                    label={'Tipo'}
                    name="tipoClasulaId"
                    options={tipoClausulaOptions}
                    span={6}
                    onChange={e => {
                      //setValueTipoClausula(e as string);
                    }}
                    allowClear
                  />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <>
            {clausulaResultAprovado && clausulaResultAprovado.length > 0 ? (
              <>
                {clausulaResultAprovado.map(clausula => {
                  return (
                    <Collapse key={`${clausula.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                      <Panel
                        key={`${clausula.id}`}
                        header={`${clausula.tipoClausulaDescricao} - ${clausula.descricao}`}>
                        {clausula.tipoClausula}
                        <Widget
                          actions={[
                            <Button
                              key="delete"
                              type="danger"
                              style={{ marginRight: '5px', marginLeft: '5px', marginBottom: '5px', float: 'right' }}
                              onClick={() => excluirClausula(clausula, `./clausulasCadastradasComItensAprovados`)}>
                              Excluir Cláusula
                            </Button>,

                            <Button
                              key="add"
                              icon="science-plus_math"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                window.location.href = `./cadastroDeItensDeClausula?id=${clausula.id}&editarItem=true`;
                              }}>
                              ADICIONAR ITEM
                            </Button>,

                            <Button
                              key="edit"
                              icon="editing-pencil"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                window.location.href = `./cadastroDeClausula?id=${clausula.id}`;
                              }}>
                              EDITAR
                            </Button>,
                          ]}>
                          {clausula && clausula.itens && clausula.itens.length > 0 ? (
                            <TabelaItensCadastrados
                              clausulaResult={clausula ? clausula : ({} as Clausula)}
                              itensRowTable={clausula.itens}
                              onUpdateRowTable={onUpdateRowTable}
                              mostraColunaComentario={true}
                              perfilResponsavelOptions={perfilResponsavelOptions}
                              clausulasComItensAprovados={clausulasComItensAprovados}
                              atualizarClausulaPendentes={atualizarClausulaPendentes}
                              handleModalDescricao={handleModalDescricao}
                              statusItemFilter={[EStatusDoItem['Aprovado']]}
                              mostrarColunaEvioParaAprovacao={false}
                            />
                          ) : (
                            <> </>
                          )}
                        </Widget>
                      </Panel>
                    </Collapse>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </>
        </GridView>

        <GridView icon="files-create_new" noform id="cadastroDeClausula" title="CADASTRO DE CLÁUSULAS">
          <Collapse
            key="cadastroDeClausula"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'cadastroDeClausula'}>
            <Panel key="cadastroDeClausula" header="NOVA CLÁUSULA">
              <MasterDetailForm
                initialValues={initialValue}
                onSubmit={update}
                validationSchema={Yup.object().shape({
                  descricao: Yup.string().required('O campo deve ser informado'),
                  tipoClausulaId: Yup.string().required('O campo deve ser informado'),
                })}>
                <Widget
                  actions={[
                    true && (
                      <>
                        <FormSubmitButton noIcon type="primary">
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>

                        <Button
                          title="Novo Item"
                          type="primary"
                          icon="commons-plus"
                          style={{ marginRight: '8px' }}
                          onClick={() => {
                            if (clausula) {
                              window.location.href = `./cadastroDeItensDeClausula?id=${clausula.id}&editarItem=true`;
                            }
                          }}
                        />

                        <Button
                          title="Nova cláusula"
                          type="primary"
                          style={{ marginRight: '8px' }}
                          onClick={mostrarConfirmacaoNovaClausula}
                        />
                      </>
                    ),
                  ]}>
                  <Row>
                    <Col span={6}>
                      <FormTextArea
                        label="Cláusula"
                        name="descricao"
                        maxLength={1000}
                        rows={6}
                        cols={60}
                        id={'clausulaDescricao'}
                      />
                    </Col>
                    <Col span={6}>
                      <FormSelect
                        label={'Tipo'}
                        name="tipoClausulaId"
                        options={tipoClausulaOptions}
                        required
                        id={'tipoClausulaId'}
                        allowClear
                      />

                      <FormSwitch
                        label="Numerada"
                        name="mostrarNumero"
                        span={3}
                        checked={clausula ? clausula.mostrarNumero : true}
                        defaultChecked={clausula ? clausula.mostrarNumero : true}
                        onChange={(e) => {
                          setClausula({ ...clausula, mostrarNumero: e } as Clausula);
                        }}
                      />
                    </Col>
                  </Row>

                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
        </GridView>

        <GridView icon="files-create_new" noform id="cadastroDeItensDeClausula" title="CADASTRO DE ITENS">
          <Collapse
            key="cadastroDeItensDeClausula"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'cadastroDeItensDeClausula'}>
            <Panel key="cadastroDeItensDeClausula" header="CADASTRO DE ITENS DE CLÁUSULA">
              <MasterDetailForm
                initialValues={initialValueFormItensClausula}
                onSubmit={submitFormItemClausulas}
                validationSchema={Yup.object().shape({
                  clausulaId: Yup.string().required('O campo deve ser informado'),
                  descricaoCompleta: Yup.string().required('O campo deve ser informado'),
                  perfilResponsavel: Yup.string().required('O campo deve ser informado'),
                })}>
                <Widget
                  actions={[
                    initialValueFormItensClausula && initialValueFormItensClausula.clausulaId && (
                      <Button
                        key="delete"
                        type="danger"
                        style={{ marginRight: '5px', marginLeft: '5px', marginBottom: '5px', float: 'right' }}
                        onClick={() =>
                          excluirClausula(
                            {
                              id: initialValueFormItensClausula.clausulaId,
                            } as Clausula,
                            `./cadastroDeItensDeClausula`,
                          )
                        }>
                        Excluir Cláusula
                      </Button>
                    ),

                    initialValueFormItensClausula && initialValueFormItensClausula.clausulaId && (
                      <Button
                        key="edit"
                        icon="editing-pencil"
                        type="primary"
                        style={{ float: 'right' }}
                        onClick={() => {
                          setFlag(false);
                          history.push(`./cadastroDeClausula?id=${initialValueFormItensClausula.clausulaId}`);
                        }}>
                        EDITAR CLÁUSULA
                      </Button>
                    ),

                    <FormSubmitButton noIcon type="primary">
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <FormSelect
                    label={'Cláusula'}
                    name="clausulaId"
                    options={clausulaOptions}
                    required
                    value={descricaoDaClausulaCadastroItem}
                    span={6}
                    onChange={e => {
                      const clausulaComTipo = getClausulaComTipo(e as string);
                      clausulaComTipo.then(data => {
                        if (data) {
                          setModalRichText({
                            ...modalRichText,
                            html: '',
                            text: '',
                          });
                          setTipoDaClausula(data.tipoClausulaId);
                          definirListadeItens(data);
                          allItemByClausulaIdPorStatus(e as string);
                          definirDescricaoDaClausulaCadastroItem(data);
                          setInitialValueFormItensClausula({ ...initialValueFormItensClausula, clausulaId: e });
                          setClausulaSelect({ id: e } as Clausula);
                        }
                      });
                    }}
                    id={'ClausulaId'}
                  />

                  <FormSelect
                    label={'Tipo da Cláusula'}
                    name="tipoClausulaId"
                    options={tipoClausulaOptions}
                    disabled
                    value={tipoDaClausula}
                    span={6}
                    id={'tipoClausulaId'}
                  />

                  <legend>ITEM DA CLÁUSULA</legend>

                  <FormInput
                    id={'itemDescricao'}
                    label="Descrição"
                    name="descricaoCompleta"
                    span={4}
                    readOnly
                    value={
                      initialValueFormItensClausula && initialValueFormItensClausula.descricaoCompleta
                        ? initialValueFormItensClausula.descricaoCompleta
                        : ''
                    }
                    onClick={() => {
                      const dadosModal = {
                        ...modalRichText,
                        title: 'Descrição',
                        html: initialValueFormItensClausula.descricaoHtml,
                        text: initialValueFormItensClausula.descricaoCompleta,
                        visible: true,
                        onOkRitchTextConteudo: (htmlString: string, textString: string) => {
                          setInitialValueFormItensClausula({
                            ...initialValueFormItensClausula,
                            descricaoCompleta: textString,
                            descricaoHtml: htmlString,
                          });
                        },
                      };

                      handleModalDescricao(dadosModal);
                    }}
                  />

                  <FormSelect
                    label="Perfil Responsável"
                    name="perfilResponsavel"
                    options={perfilResponsavelOptions}
                    span={4}
                    allowClear={true}
                  />

                  <FormSwitch
                    label="Sempre Visível"
                    name="sempreVisivel"
                    span={4}
                    checked={valueSempreVisivel}
                    onChange={e => {
                      setValueSempreVisivel(e);
                    }}
                  />

                  <ModalSelectResposta
                    limparResposta={
                      valueSempreVisivel ||
                      (initialValueFormItensClausula && initialValueFormItensClausula.resposta == '')
                    }
                    disable={valueSempreVisivel}
                    onGetRespostasSelecionadas={respostas =>
                      setRespostasSelecionadas(respostas.map(resposta => resposta.id))
                    }
                  />

                  <FormSwitch label="Não Editar" name="naoEditar" span={4} />
                  <FormSwitch label="Não Excluir" name="naoExcluir" span={4} />

                  <FormSelect
                    label="Dependente"
                    name="dependente"
                    span={12}
                    id="dependente"
                    allowClear={true}
                    options={clausulasComItensAprovados}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                      return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                    }}
                  />

                  <FormSelect
                    label="Item Pai"
                    name="itemPai"
                    options={itemListComStatusAprovado}
                    span={12}
                    allowClear={true}
                    id="itemPai"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                      return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                    }}
                  />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <Widget
            title={'Itens Cadastrados'}
            actions={[
              <Button type="primary" icon="messaging-send" onClick={() => enviarTodosParaAprovacao()}>
                ENVIAR TODOS PARA APROVAÇÃO
              </Button>,
            ]}>
            <TabelaItensCadastrados
              clausulaResult={clausulaSelect ? clausulaSelect : ({} as Clausula)}
              onUpdateRowTable={onUpdateRowTable}
              itensRowTable={itensRowTable}
              mostraColunaComentario={false}
              perfilResponsavelOptions={perfilResponsavelOptions}
              clausulasComItensAprovados={clausulasComItensAprovados}
              atualizarClausulaPendentes={atualizarClausulaPendentes}
              handleModalDescricao={handleModalDescricao}
              mostrarColunaEvioParaAprovacao={true}
              sempreMostarBotaoExcluir={true}
              statusItemFilter={[EStatusDoItem['PendenteDeEnvioParaAprovacao']]}
            />
          </Widget>
        </GridView>

        <GridView icon="ui-list" noform id="clausulasComItensEmAprovacao" title="ITENS EM APROVAÇÃO">
          <Collapse
            key="clausulasComItensEmAprovacao"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'clausulasComItensEmAprovacao'}>
            <Panel key="clausulasComItensEmAprovacao" header="PESQUISAR">
              <MasterDetailForm initialValues={{} as ClausulaPesquisa} onSubmit={loadAllClausulasPendentes}>
                <Widget
                  actions={[
                    true && (
                      <>
                        <Button
                          title="Nova Cláusula"
                          type="primary"
                          style={{ marginLeft: '8px' }}
                          onClick={() => (window.location.href = './cadastroDeClausula')}
                        />
                        <FormSubmitButton noIcon type="primary">
                          <FormatText id="ui.commons.search" uppercase />
                        </FormSubmitButton>
                      </>
                    ),
                  ]}>
                  <FormInput label="Termo de pesquisa" name="termo" span={6} />

                  <FormSelect
                    label={'Tipo'}
                    name="tipoClasulaId"
                    options={tipoClausulaOptions}
                    span={6}
                    onChange={e => {
                      //setValueTipoClausula(e as string);
                    }}
                  />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <>
            {clausulaResultPendente && clausulaResultPendente.length > 0 ? (
              <>
                {clausulaResultPendente.map(clausula => {
                  return (
                    <Collapse key={`${clausula.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                      <Panel key={`${clausula.id}`} header={`${clausula.descricao}`}>
                        {clausula.tipoClausula}
                        <Widget
                          actions={[
                            <Button
                              key="delete"
                              type="danger"
                              style={{ marginRight: '5px', marginLeft: '5px', marginBottom: '5px', float: 'right' }}
                              onClick={() => excluirClausula(clausula, `./clausulasComItensEmAprovacao`)}>
                              Excluir Cláusula
                            </Button>,

                            <Button
                              key="add"
                              icon="science-plus_math"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                window.location.href = `./cadastroDeItensDeClausula?id=${clausula.id}&editarItem=true`;
                              }}>
                              ADICIONAR ITEM
                            </Button>,

                            <Button
                              key="editItem"
                              icon="editing-pencil"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                window.location.href = `./cadastroDeItensDeClausula?id=${clausula.id}&editarItem=true`;
                              }}>
                              EDITAR ITENS
                            </Button>,

                            <Button
                              key="edit"
                              icon="editing-pencil"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                history.push(`./cadastroDeClausula?id=${clausula.id}`);
                              }}>
                              EDITAR
                            </Button>,
                          ]}>
                          <TabelaItensCadastrados
                            clausulaResult={clausula}
                            itensRowTable={clausula.itens}
                            onUpdateRowTable={onUpdateRowTable}
                            mostraColunaComentario={false}
                            perfilResponsavelOptions={perfilResponsavelOptions}
                            clausulasComItensAprovados={clausulasComItensAprovados}
                            atualizarClausulaPendentes={atualizarClausulaPendentes}
                            handleModalDescricao={handleModalDescricao}
                            statusItemFilter={[
                              EStatusDoItem['Reprovado'],
                              EStatusDoItem['AprovacaoClausulaNivel1'],
                              EStatusDoItem['AprovacaoClausulaNivel2'],
                            ]}
                            mostrarColunaEvioParaAprovacao={false}
                            mostarBotaoCancelarAprovacaoAdm={true}
                          />
                        </Widget>
                      </Panel>
                    </Collapse>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </>
        </GridView>

        <GridView icon="editing-drag_reorder" noform id="ordemClausula" title="ORDENAÇÃO">
          <Collapse
            key="ordenacaoClausula"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'ordenacaoClausula'}>
            <Panel key="ordenacaClausula" header="Cláusulas">
              <TabelaOrdenacaoClausulas atualizarTelaListaClausula={getAllClausula} />
            </Panel>
          </Collapse>
        </GridView>
      </CompositeView>

      <ModalRichText
        title={modalRichText.title}
        initialValue={modalRichText.html}
        visible={modalVisivel}
        onOkRichText={(htmlString, textString) => {
          modalRichText.onOkRitchTextConteudo(htmlString, textString);
          handleChangeModalVisible();
        }}
        onCancel={handleChangeModalVisible}
      />
    </SimpleView>
  );
};

export default Clausula;
